module.exports = __webpack_public_path__ + "img/caret-down.fc14491b.svg";